import type { FC } from "react";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

/**
 * Значок платного контента на миниатюре в списках видео и стримов: тёмный
 * кружок со знаком «$» в левом верхнем углу, как в прежнем кабинете.
 * У бесплатного контента значка нет. Платность считает бэкенд
 * (Content.premium: продукт самого контента или его коллекции).
 */
export const PremiumBadge: FC<{ title: string }> = ({ title }) => (
  <Tooltip title={title}>
    <Avatar
      sx={{
        position: "absolute",
        top: 4,
        left: 4,
        width: 22,
        height: 22,
        bgcolor: "rgba(0,0,0,0.85)",
        color: "#fff",
      }}
    >
      <AttachMoneyIcon sx={{ fontSize: 16 }} />
    </Avatar>
  </Tooltip>
);
